export { findClosestMatchFromDefaultList } from '@splunk/visualization-encoding/utils/findClosestMatchFromDefaultList';
export type { GeoJsonDataType } from '@splunk/visualization-encoding/utils/findClosestMatchFromDefaultList';
